export default __webpack_public_path__ + "static/banner-desktop-ac667f7c003c5c79a54951fe94456067.svg";